
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/auth";
import RefundFormContent from "@/components/refund/RefundFormContent";

const RefundRequest = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  // Handle completion callback
  const handleCompletedForm = () => {
    // Navigation handled by submission hook
  };

  return (
    <div className="container max-w-4xl py-10">
      <div className="mb-8">
        <h1 className="text-3xl font-bold tracking-tight">Create Refund Request</h1>
        <p className="text-muted-foreground mt-2">
          Fill out the form below to create a new refund request
        </p>
      </div>

      <RefundFormContent onCompletedCallback={handleCompletedForm} />
    </div>
  );
};

export default RefundRequest;
